import firebase from "firebase/compat/app";

const ALPHA_PROJECT_IDS = new Set(["mosaic-vision-alpha"]);

export function isAlphaProjectId(projectId?: string | null): boolean {
  return typeof projectId === "string" && ALPHA_PROJECT_IDS.has(projectId);
}

export function isProductionDeployment(): boolean {
  const options = firebase.app()?.options as { projectId?: string } | undefined;
  const projectId = options?.projectId;
  if (!projectId) {
    return true;
  }
  return !isAlphaProjectId(projectId);
}
